// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.87.1-next',
  revision: '53b0af1d',
  branch: 'next',
  date: 'Tue, 31 Mar 2026 11:11:02 GMT'
};